// extracted by mini-css-extract-plugin
module.exports = {"large":"only screen and (min-width: 992px)","box":"_2riB8"};